module.exports = __webpack_public_path__ + "img/ash.2a35f4cb.png";